// src/lib/demoClient.js — the browser's one reading of "is this the demo?"
//
// VITE_DEMO_MODE=1 is set ONLY on the demo Vercel project (docs/specs/
// DEMO-ENVIRONMENT-v0.1.md §3.3), as plain Config — never Sensitive, or the
// prebuilt deploy ships an 11-character placeholder and the demo silently
// renders as production. src/lib/studioUrl.js already reads the same var.
//
// Everything client-side that behaves differently in the trailer imports
// IS_DEMO from here, and nothing else reads import.meta.env for it.
import { demoLabel, entityLabelFor, applyDemoLabels, demoProseTree } from './demoBrand.js'

export const IS_DEMO = import.meta.env?.VITE_DEMO_MODE === '1'

// Three of the guided rail's fourteen scenes (src/lib/demoScenes.js's
// STUDIO_GATED_KEYS: 'pages', 'episodes', 'promo') read Studio pictures that
// a separate, human-run step (scripts/demo/eighty-days-art.mjs + a re-apply
// of the seed) generates and uploads AFTER this code deploys — see
// docs/demo/eighty-days-content-manifest.md. Off (unset) is the safe
// default: the tour simply does not advertise or route to those three
// screens until this is explicitly turned on, once that step has actually
// run against the live deploy. Plain Config, never Sensitive — any VITE_
// var is public in the bundle regardless (CLAUDE.md's own standing rule).
export const EIGHTY_DAYS_STUDIO_READY = import.meta.env?.VITE_DEMO_EIGHTY_DAYS_STUDIO_READY === '1'

export const DEMO_SESSION_KEY = 'chatrone.demo.session'

/** A display string, rebranded to Meridian in the trailer. */
export const label = (text) => demoLabel(text, IS_DEMO)

/** The label for a company_id partition key ('chatrone_us' | 'chatrone_latam'). */
export const entityLabel = (companyId, opts) => entityLabelFor(companyId, IS_DEMO, opts)

/** Any JSON tree with the company's name rewritten mid-sentence; the same object outside the demo. */
export const demoProseData = (tree) => demoProseTree(tree, IS_DEMO)

/** A translations tree with entity labels rewritten; the same object outside the demo. */
export const demoTranslations = (tree) => applyDemoLabels(tree, IS_DEMO)

export function readDemoSessionId() {
  try { return sessionStorage.getItem(DEMO_SESSION_KEY) || null } catch { return null }
}
export function writeDemoSessionId(id) {
  try { if (id) sessionStorage.setItem(DEMO_SESSION_KEY, id); else sessionStorage.removeItem(DEMO_SESSION_KEY) } catch { /* private mode */ }
}

/** Report a rail step. Best-effort and never awaited by the UI. */
export function recordDemoEvent(event, scene, detail) {
  if (!IS_DEMO) return
  const demo_session_id = readDemoSessionId()
  if (!demo_session_id) return
  try {
    fetch('/api/demo-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ demo_session_id, event, scene, detail }),
      keepalive: true,
    }).catch(() => {})
  } catch { /* offline */ }
}
